import {Component, Input} from "@angular/core";
import {RiskFactor, ScoringAlert, ScreeningAlert} from "../../../../../../model/lookup-results.model";
import {LookupService} from "../../../../lookup.service";

@Component({
  selector: "admin-lookup-factor-scoring",
  templateUrl: "./scoring.component.html",
  styleUrls: ["./scoring.component.css"]
})
export class AdminLookupFactorScoringComponent {

  @Input() factor: RiskFactor

  constructor(
    private singleService: LookupService,
  ) {
  }

  riskClass(alert: ScoringAlert) {
    return this.singleService.riskClass(alert.risk!);
  }
}
